import { FontIcon, Stack, Text } from '@fluentui/react';
import clsx from 'clsx';
import { useCommonStyles } from 'common/styles';
import { INavItem, SVGIconOrFontIconName } from 'nav/navGroups';
import React from 'react';
import { Link } from 'react-router-dom';
import { useStyles } from './index.styles';

interface NavItemProps {
  text: string;
  Icon: SVGIconOrFontIconName;
  to: string;
  expanded: boolean;
  active?: boolean;
  smallIcon?: boolean;
  compact?: boolean;
  bold?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  id?: string;
  onLinkClick?: () => void;
  className?: string;
  navItemProps: INavItem;
}

export const NavItem: React.FC<NavItemProps> = ({
  text,
  to,
  Icon,
  expanded,
  active,
  smallIcon,
  bold,
  onMouseEnter,
  onMouseLeave,
  id,
  compact,
  onLinkClick,
  className,
  navItemProps,
}) => {
  const styles = useStyles();
  const commonStyles = useCommonStyles();

  return (
    <Link
      id={id}
      to={to}
      className={clsx(
        compact ? styles.linkLightHover : styles.linkHover,
        styles.link,
        className
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onLinkClick}
    >
      <Stack
        className={clsx(active && styles.active)}
        horizontal
        verticalAlign="center"
        grow
      >
        <Stack
          className={
            compact ? styles.compactIconContainer : styles.iconContainer
          }
          horizontalAlign="center"
        >
          {typeof Icon === 'string' ? (
            <FontIcon
              className={smallIcon ? styles.smallIcon : styles.largeIcon}
              iconName={Icon}
            />
          ) : text === 'Approvals' && !!navItemProps.count ? (
            <Stack horizontal className={styles.root}>
              <Stack className={styles.badge}>
                <Text
                  className={clsx(styles.textStyles, commonStyles.bold)}
                  style={{ padding: 3 }}
                >
                  {navItemProps.count}
                </Text>
              </Stack>
            </Stack>
          ) : (
            <Icon className={smallIcon ? styles.smallIcon : styles.largeIcon} />
          )}
        </Stack>
        {expanded && (
          <Text className={clsx(bold && commonStyles.semibold)} nowrap block>
            {text}
          </Text>
        )}
      </Stack>
    </Link>
  );
};
